import {
  createExtensionInput,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import {
  EntityContentBlueprint,
  EntityCardBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityContentLayout } from './EntityContentLayout';

const CARD_ORDER = [
  'entity-card:catalog-graph/relations',
  'entity-card:catalog/depends-on-resources',
  'entity-card:catalog/depends-on-components',
  'entity-card:catalog/has-subcomponents',
];

const cardOrder = (id: string) => {
  const idx = CARD_ORDER.indexOf(id);
  return idx === -1 ? Infinity : idx;
};

export const catalogOverviewOverride = EntityContentBlueprint.makeWithOverrides(
  {
    name: 'overview',
    inputs: {
      cards: createExtensionInput([
        coreExtensionData.reactElement,
        EntityContentBlueprint.dataRefs.filterFunction.optional(),
        EntityCardBlueprint.dataRefs.type.optional(),
      ]),
    },
    factory(originalFactory, { inputs }) {
      const sortedCards = [...inputs.cards].sort(
        (a, b) => cardOrder(a.node.spec.id) - cardOrder(b.node.spec.id),
      );

      return originalFactory({
        path: '/',
        title: 'Overview',
        group: 'overview',
        loader: async () => {
          const cards = sortedCards.map(card => ({
            element: card.get(coreExtensionData.reactElement),
            type: card.get(EntityCardBlueprint.dataRefs.type),
            filter:
              card.get(EntityContentBlueprint.dataRefs.filterFunction) ??
              (() => true),
          }));

          const Component = () => {
            const { entity } = useEntity();
            return (
              <EntityContentLayout
                cards={cards.filter(c => c.filter(entity))}
              />
            );
          };

          return <Component />;
        },
      });
    },
  },
);
